import GooseScan from './GooseScan'

export default GooseScan